<ng-container *ngFor="let table of sectionData">
    <table style="width: 100%">
        <ng-container *ngFor="let row of table; let i = index">
            <ng-container *ngIf="row.rowType === 'TableHead'">
                <thead>
                    <tr
                        [style.color]="tableHeaderColor"
                        class="big-row-min-height_plus-border-height black-border-down header"
                    >
                        <th class="title text-align-bottom">
                            <div class="big-row-min-height_plus-border-height">{{ row.t }}</div>
                        </th>
                        <th class="value text-align-bottom" [style.background-color]="backgroundColor">{{ row.pV }}</th>
                        <th class="value-col text-align-bottom">{{ row.col1 }}</th>
                        <th class="value-col text-align-bottom">{{ row.col2 }}</th>
                        <th class="value-col text-align-bottom">{{ row.col3 }}</th>
                        <th class="value-col text-align-bottom">{{ row.col4 }}</th>
                        <th class="value text-align-bottom" [style.background-color]="backgroundColor">{{ row.cV }}</th>
                    </tr>
                </thead>
            </ng-container>

            <ng-container *ngIf="row.rowType === 'Row'">
                <tr [style.color]="textColor" class="row-min-height_plus-border-height gray-border-down">
                    <td class="title text-align-top">{{ row.t }}</td>
                    <td class="value text-align-top" [style.background-color]="backgroundColor">{{ row.pV }}</td>
                    <td class="value-col text-align-top">{{ row.col1 }}</td>
                    <td class="value-col text-align-top">{{ row.col2 }}</td>
                    <td class="value-col text-align-top">{{ row.col3 }}</td>
                    <td class="value-col text-align-top">{{ row.col4 }}</td>
                    <td class="value text-align-top" [style.background-color]="backgroundColor">{{ row.cV }}</td>
                </tr>
            </ng-container>
            <ng-container *ngIf="row.rowType === 'Footnote'">
                <tr [style.color]="textColor" class="footnote row-min-height_plus-border-height">
                    <td class="title text-align-top" colspan="7">{{ row.t }}</td>
                </tr>
            </ng-container>
            <ng-container *ngIf="row.rowType === 'GroupTotal' || row.rowType === 'TableTotal'">
                <tr
                    [style.color]="tableFooterColor"
                    class="row-min-height_plus-border-height big-row-min-height_plus-border-height ng-star-inserted"
                >
                    <td class="title row-min-height black-border-down bolder-bigger big-row-min-height text-align-top">
                        <span> {{ row.t }}</span>
                    </td>

                    <td
                        class="value black-border-down bolder-bigger big-row-min-height text-align-top"
                        [style.background-color]="backgroundColor"
                    >
                        {{ row.pV }}
                    </td>
                    <td class="value-col black-border-down bolder-bigger big-row-min-height text-align-top">
                        {{ row.col1 }}
                    </td>
                    <td class="value-col black-border-down bolder-bigger big-row-min-height text-align-top">
                        {{ row.col2 }}
                    </td>
                    <td class="value-col black-border-down bolder-bigger big-row-min-height text-align-top">
                        {{ row.col3 }}
                    </td>
                    <td class="value-col black-border-down bolder-bigger big-row-min-height text-align-top">
                        {{ row.col4 }}
                    </td>
                    <td
                        class="value black-border-down bolder-bigger big-row-min-height text-align-top"
                        [style.background-color]="backgroundColor"
                    >
                        {{ row.cV }}
                    </td>
                </tr>
            </ng-container>
        </ng-container>
    </table>
    <br />
</ng-container>
